import { Loader2, AlertCircle, Inbox } from "lucide-react";

export function Spinner({ label }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground" data-testid="loading-spinner">
      <Loader2 className="h-7 w-7 animate-spin text-primary" />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center" data-testid="empty-state">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary text-primary">
        <Icon className="h-8 w-8" />
      </div>
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        {hint ? <p className="mt-1 text-sm text-muted-foreground">{hint}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong.", onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center" data-testid="error-state">
      <AlertCircle className="h-8 w-8 text-destructive" />
      <p className="text-sm text-muted-foreground">{message}</p>
      {onRetry ? (
        <button data-testid="retry-button" onClick={onRetry} className="rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground">
          Retry
        </button>
      ) : null}
    </div>
  );
}
